import { Routes, Route } from "react-router-dom";
import MasterPage from "./Layout/MasterPage.js";
import Report from "./Report/index.js";
import About from "./About/index.js";
import ContactUs from "./ContactUs/index.js";

export default function App() {
  return (
    <Routes>
      <Route element={<MasterPage />} >
        <Route path="/" index element={<Report />} />
        <Route path="AboutBarpazir" element={<About />} />
        <Route path="ContactUs" element={<ContactUs />} />
        <Route path="*"
          element={
            <main style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height:"100%",
              color:"white",
              fontSize: "18px"
              }}>
              Page not found! (404)
            </main>
          }
        />
      </Route>
    </Routes>
  );
}
